<!-- 销售单详情，目前用于装箱单编辑页面 -->
<template>
    <div class="salectn">
        <!--   form     -->
        <div class="section-title">
            <div>
                <span>订单信息</span>
                <span style="font-size: 14px; margin-left: 10px; color: red">（ 订单编号：{{ submitData.OrderCode }} ）</span>
            </div>
        </div>
        <div class="search-ctn p-order-info">
            <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 15px; padding-left: 15px">
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客户名称" prop="EntpCusId">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.EntpCusName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="业务员" prop="SName">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.SName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="联系电话" prop="PhoneNum">
                                <el-input size="small" :disabled="dataReadonly" v-model="submitData.PhoneNum"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="发货方式" prop="ShipTypeName">
                                <el-input size="small" :disabled="dataReadonly" v-model="submitData.ShipTypeName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="运输费用" prop="ShipAmount">
                                <el-input size="small" min="0" type="number" step="0.01" :disabled="dataReadonly" v-model.trim="submitData.ShipAmount"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="结算方式" prop="PayTypeName">
                                <el-input size="small" :disabled="dataReadonly" v-model="submitData.PayTypeName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6" v-if="funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="跟单采购员" prop="FollowerName">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.FollowerName"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12" v-if="!funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.FullAddress"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="9" v-if="funcConfig">
                        <div class="grid-content bg-purple">
                            <el-form-item label="收货地址" prop="FullAddress">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.FullAddress"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="funcConfig ? 9 : 12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客人要求">
                                <el-input size="small" style="width: 100%" :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!--    table    -->
        <div class="section-title">
            <div>商品明细</div>
        </div>
        <div class="edit-ctn" id="editCtn">
            <!--      table title      -->
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 5%; flex-grow: 1">序号</div>
                <div class="div-table-cell" style="width: 15%">汽配编码</div>
                <div class="div-table-cell" style="width: 15%">配件名称</div>
                <div class="div-table-cell" style="width: 10%">车型</div>
                <div class="div-table-cell" style="width: 10%">数量</div>
                <div class="div-table-cell" style="width: 10%">单位</div>
                <div class="div-table-cell" style="width: 10%">参考售价</div>
                <div class="div-table-cell" style="width: 10%">销售价</div>
                <div class="div-table-cell" style="width: 10%">销售总价</div>
                <div class="div-table-cell" style="width: 5%">库存</div>
            </div>
            <div class="table-main">
                <div class="div-table-row table-item" v-for="(item, index) in dataList" :ref="'pj' + index" :key="index">
                    <div class="div-table-cell" style="width: 5%; flex-grow: 1">{{ item.SortNum }}</div>
                    <!--        编码            -->
                    <div class="div-table-cell" style="width: 15%" :class="{ 'check-code-class': item.CodeRepeat }">
                        <el-tooltip effect="dark" :content="item.APCode" placement="top">
                            <span>{{ item.APCode }}</span>
                        </el-tooltip>
                    </div>
                    <!--        名称            -->
                    <div class="div-table-cell" style="width: 15%">
                        <el-tooltip effect="dark" :content="item.GoodName" placement="top">
                            <span>{{ item.GoodName }}</span>
                        </el-tooltip>
                    </div>
                    <!--        车系            -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="item.AutoSerise" placement="top">
                            <span>{{ item.AutoSerise }}</span>
                        </el-tooltip>
                    </div>
                    <!--        数量            -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="item.Count.toString()" placement="top">
                            <span>{{ item.Count.toString() }}</span>
                        </el-tooltip>
                    </div>
                    <!--        单位         -->
                    <div class="div-table-cell" style="width: 10%">{{ item.Unit }}</div>
                    <!--        参考售价           -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="item.ReferencePrice.toString()" placement="top">
                            <span>{{ item.ReferencePrice.toString() }}</span>
                        </el-tooltip>
                    </div>
                    <!--          销售价          -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="item.MarketPrice.toString()" placement="top">
                            <span>{{ item.MarketPrice.toString() }}</span>
                        </el-tooltip>
                    </div>
                    <!--          销售总价          -->
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="(item.MarketPrice * item.Count ? item.MarketPrice * item.Count : 0).toFixed(2).toString()" placement="top">
                            <span>
                                {{ (item.MarketPrice * item.Count ? item.MarketPrice * item.Count : 0).toFixed(2).toString() }}
                            </span>
                        </el-tooltip>
                    </div>
                    <!--          库存         -->
                    <div class="div-table-cell" style="width: 5%">
                        <el-tooltip effect="dark" :content="item.Inventory.toString()" placement="top">
                            <span>{{ item.Inventory.toString() }}</span>
                        </el-tooltip>
                    </div>
                </div>
                <div class="div-table-row table-item">
                    <div class="div-table-cell" style="width: 5%; flex-grow: 1"></div>
                    <div class="div-table-cell" style="width: 15%"></div>
                    <div class="div-table-cell" style="width: 15%"></div>
                    <div class="div-table-cell" style="width: 10%">总数量</div>
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="allNum.toString()" placement="top">
                            <span>{{ allNum.toString() }}</span>
                        </el-tooltip>
                    </div>
                    <div class="div-table-cell" style="width: 10%"></div>
                    <div class="div-table-cell" style="width: 10%"></div>
                    <div class="div-table-cell" style="width: 10%">销售商品总额</div>
                    <div class="div-table-cell" style="width: 10%">
                        <el-tooltip effect="dark" :content="allMoney.toFixed(3).toString()" placement="top">
                            <span>{{ allMoney.toFixed(3).toString() }}</span>
                        </el-tooltip>
                    </div>
                    <div class="div-table-cell" style="width: 5%"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '@/mixins/mixin';
export default {
    props: {
        EntpCusOId: {
            type: String
        }
    },
    name: '',
    components: {},
    data() {
        return {
            dataReadonly: true,
            allNum: 1,
            allMoney: 0,
            submitData: {
                SName: '',
                FollowerName: '',
                ShipAmount: '',
                EntpCusName: '',
                PayTypeName: '',
                ShipTypeName: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: []
            },
            id: '',
            dataList: [],
            funcConfig: false
        };
    },
    mounted() {
        this.getEntpFuncConfigData();
        this.id = this.EntpCusOId;
        this.getOrderDetail();
    },
    methods: {
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _lack = false; // 库存是否紧缺
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
                if (DetailList[i].Inventory - DetailList[i].WaitingOutQuantity <= 0) {
                    _lack = true;
                }
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.dataList = DetailList;
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetOrderById',
                    data: {
                        EntpCusOId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    this.submitData = data;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        DetailList[i].MarketPrice = DetailList[i].Price;
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                    }

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        //获取企业的功能设置结果
        getEntpFuncConfigData() {
            this.$util.getSysConfig('xsgdy').then(res => {
                this.funcConfig = res.Result;
            });
        }
    }
};
</script>
<style lang="less" scoped>
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    margin-bottom: 10px;
}
.table-main {
    position: relative;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 36px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
}
.salectn {
    margin-bottom: 20px;
    margin-top: 20px;
    padding-bottom: 20px;
}

.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>
<style lang="less">
.p-order-info {
    margin-bottom: 10px;
    .el-form {
        padding-top: 10px;
    }
    .el-row {
        padding-bottom: 10px;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }

    .form-main {
        display: flex;
        align-items: center;
    }
}
</style>
